// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Download as RawDownload } from "lucide-react";
export const Download = /* @__PURE__ */ createIcon(RawDownload, "Download", 2);
